import { FC, useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Button, Flex, message, Result } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Container } from "../../../core/component";
import { translate } from "../../../core";
import { PurchaseOrderQuery } from "../graphql/purchase-order.graphql";
import { PurchaseOrderListItem } from "./PurchaseOrderListItem";
import { PurchaseOrderListItemContext } from "./PurchaseOrderListItemContext";
import { readPurchaseOrderListLocation } from "../hook/purchase-order-list-state.hook";

export const PurchaseOrderDetailPage: FC = () => {
  const { poNumber } = useParams<{ poNumber: string }>();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const backTo = useMemo(() => readPurchaseOrderListLocation(), []);

  const number = Number(poNumber);

  const { data, loading } = useQuery(PurchaseOrderQuery, {
    notifyOnNetworkStatusChange: true,
    skip: !poNumber || Number.isNaN(number),
    variables: {
      request: {
        take: 1,
        skip: 0,
        number,
      },
    },
  });

  const entity = data?.purchaseOrdersFind.data[0];

  return (
    <Container loading={loading}>
      {contextHolder}

      <Flex justify="start" className="mb-3">
        <Link to={backTo}>
          <Button icon={<ArrowLeftOutlined />}>{translate("back")}</Button>
        </Link>
      </Flex>

      {!loading && !entity ? (
        <Result
          status="404"
          title={`${translate("purchase_order_nu_abbr")} #${poNumber}`}
          subTitle={translate("purchase_order_not_found")}
          extra={
            <Link to={backTo}>
              <Button type="primary">{translate("back")}</Button>
            </Link>
          }
        />
      ) : entity ? (
        <PurchaseOrderListItemContext.Provider
          value={{
            entity,
            message: messageApi,
            onAfterDelete: () => navigate(backTo),
          }}
        >
          <PurchaseOrderListItem />
        </PurchaseOrderListItemContext.Provider>
      ) : null}
    </Container>
  );
};
